var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73438 9.73438C2.11965 9.73438 0 7.61472 0 5C0 2.38528 2.11965 0.265625 4.73438 0.265625C5.83179 0.265625 6.84199 0.639006 7.64488 1.26566L14.2656 1.26562C16.3281 1.26562 18 2.93756 18 5C18 7.06244 16.3281 8.73438 14.2656 8.73438L7.64479 8.73441C6.84192 9.36102 5.83175 9.73438 4.73438 9.73438ZM8.03142 4.99996C8.03142 6.82089 6.55526 8.29704 4.73434 8.29704C2.91341 8.29704 1.43726 6.82089 1.43726 4.99996C1.43726 3.17903 2.91341 1.70288 4.73434 1.70288C6.55526 1.70288 8.03142 3.17903 8.03142 4.99996ZM16.5935 5C16.5935 6.28566 15.5513 7.32788 14.2656 7.32788L8.85771 7.32816C9.24671 6.64069 9.46875 5.84627 9.46875 5C9.46875 4.15375 9.24672 3.35937 8.85774 2.67191L14.2656 2.67212C15.5513 2.67212 16.5935 3.71434 16.5935 5Z",
    fill: "#677C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.7d63c52a1d333810e013e4b932f4523d.svg";
export { ForwardRef as ReactComponent };